import { EditorBookingItemBulkName } from './editor-booking-item-bulk-name-edit/editor-booking-item-bulk-name-edit.store';


export function getLevelLinesListFromItemList(itemList: EditorBookingItemBulkName[]): boolean[][] {
  const levelLinesList: boolean[][] = [];

    itemList.forEach(item => {
      if (levelLinesList.length) {
        levelLinesList.push([
          ...levelLinesList[levelLinesList.length - 1].slice(0, item.level - 1),
          !item.isLastSibling
        ]);
      } else {
        levelLinesList.push([!item.isLastSibling]);
      }
    });

    return levelLinesList;
}
